(function () {
  class Freespins {
    constructor() {
      var self = this;
      this._startHolder = undefined;
      this._endHolder = undefined;
      this._fsCountText = undefined;
      this._fsWinningsMeter = undefined;
      this._fsActive = false;
      this._freespinsCount = 0;
      this._spinsLeft = 0;
      this._outroPopup = undefined;
      this._outroPopupButton = undefined;
      this._winningsThisSpin = 0;
      this._gameLoaded = false;
      this._skipOutroMove = false;
      this._waitForPopup = false;
      this._initLevel = 0;

      this._anchorLockPool = [];
      this._anchorLockCreated = 0;
      this._anchorLocks = [];
      this._upgrades = [];
      this._upgradesCreated = 0;

      this._doSpinFunc = this.doSpin.bind(this);
      this._doSpinDeadFunc = this.doSpinDead.bind(this);
      messageBus.subscribe("spinner:GameConfigEvent", this.onGameConfigEvent.bind(this));
      messageBus.subscribe("spinner:FreeSpinsStartEvent", this.onFreespinsStart.bind(this));
      messageBus.subscribe("spinner:FreeSpinsStartEventDead", this.onFreespinsStartDead.bind(this));
      messageBus.subscribe("spinner:FreeSpinsDataEvent", this.onFreespinsData.bind(this));
      messageBus.subscribe("spinner:FreeSpinsDataEventDead", this.onFreespinsDataDeadEvent.bind(this));
      messageBus.subscribe("spinner:FreeSpinsRetriggerEvent", this.onFreespinsRetriggerEvent.bind(this));
      messageBus.subscribe("spinner:FreeSpinsEndEvent", this.onFreespinsEndEvent.bind(this));
      messageBus.subscribe("spinner:FreeSpinsEndEventDead", this.onFreespinsEndEventDead.bind(this));
      messageBus.subscribe("spinner:WinningLinesEvent", this.doPayWins.bind(this));
      this._payWinsDeadFunc = this.doPayWinsDead.bind(this);
      Reflex.registerEventHandler("orientationChange", this.onOrientationChange.bind(this));
      Reflex.registerEventHandler("layoutChange", this.onLayoutChange.bind(this));
      messageBus.subscribe("spinner:FreeSpinsAwardEvent", this.onFreespinsAwarded.bind(this));
      messageBus.subscribe("spinner:FreeSpinsAwardEventDead", this.onFreespinsAwardedEnd.bind(this));
      messageBus.subscribe("freeSpins:removeLocks", this.removeAnchorLocks.bind(this));

      StateMachine.Create(this);
      Reflex.addToUpdate(function (delta, time) {
        self.update(delta, time);
      });

      this.stateMachine.addState("IDLE", function () {});
    }

    update(delta, time) {
      if (this.stateMachine) {
        this.stateMachine.update();
      }
    }

    onOrientationChange() {
      if (!this._gameLoaded) {
        return;
      }

      const scale = resourceManager.get("slotContainer").scale;

      this._anchorLocks.forEach((anchorLock) => {
        const coord = helpers.getSymbolPos(anchorLock.cell.reel, anchorLock.cell.row);
        anchorLock.anchor.x = coord.x;
        anchorLock.anchor.y = coord.y;
        anchorLock.anchor.scale = scale;
        anchorLock.lock.x = coord.x;
        anchorLock.lock.y = coord.y;
        anchorLock.lock.scale = scale;
        anchorLock.reverseAnchor.x = coord.x;
        anchorLock.reverseAnchor.y = coord.y;
        anchorLock.reverseAnchor.scale = scale;
        anchorLock.reverseLock.x = coord.x;
        anchorLock.reverseLock.y = coord.y;
        anchorLock.reverseLock.scale = scale;
      });

      this._skipOutroMove = true;

      if (this._fsActive) {
        this.updateMeterText(true);
        this.updateButtonPositions(true);
      } else {
        this.updateMeterText(false);
        this.updateButtonPositions(false);
      }
    }

    onLayoutChange() {
      if (this._winlineTab) {
        if (gameController.inFreeSpins) {
          this._winlineTab.visible = true;
          this._winlineTabPortrait.visible = true;
        } else {
          this._winlineTab.visible = false;
          this._winlineTabPortrait.visible = false;
        }
      }
      if (this._fsActive) {
        //const fsCreditMeterPos = resourceManager.get('creditContainer_freespinsPosition').position;
        //this._baseCreditMeterContainer.position.set(fsCreditMeterPos.getX(), fsCreditMeterPos.getY());
        //const fsStakeMeterPos = resourceManager.get('betContainer_freespinsPosition').position;
        //this._baseStakeMeterContainer.position.set(fsStakeMeterPos.getX(), fsStakeMeterPos.getY());

        this.onOrientationChange();
      }
    }

    hideAllAnimations() {}

    onGameConfigEvent() {
      this._gameLoaded = true;

      this._freeSpinsIntroOutro = resourceManager.get("freeSpinsIntroOutroContainer:FreeSpinsIntroOutro");
      this._trailPanel = resourceManager.get("freeSpinsTrailPanel");
      this._trailPanelContainer = resourceManager.get(
        "freeSpinsTrailPanel:freeSpinsTrailPanelContainer:freeSpinsTrailPanelScale"
      );
      this._trailPanelContainer.visible = false;

      this._upgradePopup = resourceManager.get("upgradePopup:FreeSpinsUpgradePopup");

      this._logo = resourceManager.get("postReels:logoContainerLandscape");

      this._baseFadeAssets = [
        resourceManager.getContainer("backgroundContainer"),
        resourceManager.get("preReels:reelBackersBase"),
      ];

      this._fsFadeAssets = [
        resourceManager.getContainer("fsBackgroundContainer"),
        resourceManager.get("preReels:reelBackersFS"),
      ];

      for (let i = 0; i < this._fsFadeAssets.length; i++) {
        this._fsFadeAssets[i].visible = false;
      }

      this.buttonCreditPanel = resourceManager.get("meterContainer:credit");
      this.buttonWinningsPanel = resourceManager.get("meterContainer:winnings");
      this.buttonStakePanel = resourceManager.get("meterContainer:stake");
      this.buttonFreeSpinPanel = resourceManager.get("meterContainer:freespinsMeterContainer");
      this.buttonFreeSpinValue = resourceManager.get("meterContainer:freespinsMeterContainer:value");
      this.buttonFreeSpinPanel.visible = false;

      this.updateMeterText(false);
      this.updateButtonPositions(false);
    }

    updateCountText() {
      if (this._fsActive && this._gameLoaded) {
        this.buttonFreeSpinValue.setTranslationParameters(this._freespinsCount - this._spinsLeft, this._freespinsCount);
      }
    }

    updateMeterText(inFreeSpins) {
      if (this.buttonCreditPanel && this._gameLoaded) {
        if (inFreeSpins) {
          this.buttonCreditPanel.position = resourceManager.get("meterContainer:creditPosFreeSpins").position;
          this.buttonWinningsPanel.position = resourceManager.get("meterContainer:winningsPosFreeSpins").position;
          this.buttonStakePanel.position = resourceManager.get("meterContainer:stakePosFreeSpins").position;
          this.buttonFreeSpinPanel.position = resourceManager.get("meterContainer:freeSpinsPosFreeSpins").position;
          this.buttonFreeSpinPanel.visible = true;
        } else {
          this.buttonCreditPanel.position = resourceManager.get("meterContainer:creditPosNormal").position;
          this.buttonWinningsPanel.position = resourceManager.get("meterContainer:winningsPosNormal").position;
          this.buttonStakePanel.position = resourceManager.get("meterContainer:stakePosNormal").position;
          this.buttonFreeSpinPanel.position = resourceManager.get("meterContainer:freeSpinsPosNormal").position;
          this.buttonFreeSpinPanel.visible = false;
        }
      }
    }

    updateButtonPositions(inFreeSpins) {
      if (!this._gameLoaded) {
        return;
      }

      if (inFreeSpins) {
        if (
          layoutController.getCurrentLayout() === "landscape_mobile" ||
          layoutController.getCurrentLayout() === "landscape_default"
        ) {
          resourceManager.get("buttonContainer:buttonBar:settingsMenu").visible = false;
          resourceManager.get("buttonContainer:buttonBar:stakeButton").visible = false;
          resourceManager.get("buttonContainer:buttonBar:autoplayButton").visible = false;
        } else if (
          layoutController.getCurrentLayout() === "portrait_mobile" ||
          layoutController.getCurrentLayout() === "portrait_default"
        ) {
          resourceManager.get("buttonContainer:buttonBar:settingsMenu").visible = false;
          resourceManager.get("buttonContainer:buttonBar:stakeButton").visible = false;
          resourceManager.get("buttonContainer:buttonBar:autoplayButton").visible = false;
        }
      } else {
        if (
          layoutController.getCurrentLayout() === "landscape_mobile" ||
          layoutController.getCurrentLayout() === "landscape_default"
        ) {
          resourceManager.get("buttonContainer:buttonBar:settingsMenu").visible = true;
          resourceManager.get("buttonContainer:buttonBar:stakeButton").visible = true;
          resourceManager.get("buttonContainer:buttonBar:autoplayButton").visible = true;
        } else if (
          layoutController.getCurrentLayout() === "portrait_mobile" ||
          layoutController.getCurrentLayout() === "portrait_default"
        ) {
          resourceManager.get("buttonContainer:buttonBar:settingsMenu").visible = true;
          resourceManager.get("buttonContainer:buttonBar:stakeButton").visible = true;
          resourceManager.get("buttonContainer:buttonBar:autoplayButton").visible = true;
        }
      }
    }

    doSpin() {
      this._winningsThisSpin = 0;
      this.updateCountText();
    }

    doSpinDead(spinTask) {}

    getNextSpinOutcome() {
      this.updateCountText();
      gameController.initNewSpin();
      gdk.getNextGameOutcome(function () {});
    }

    onFreespinsStart(task) {
      gameController.slotMachine.clearDimSymbolIds();

      this._initLevel = task.data.initialTrailLevel;

      gameController.trailLevel = this._initLevel;

      resourceManager.getController("inputOverlord").setState("freespinsEnabled");
      messageBus.subscribe("spinner:SpinEvent", this._doSpinFunc);
      messageBus.subscribe("spinner:SpinEventDead", this._doSpinDeadFunc);
      messageBus.subscribe("spinner:WinningLinesEventDead", this._payWinsDeadFunc);

      this._winnings = task.data.bonusWin + gameController.preFSReelPrize;
      this._freespinsCount = task.data.freeSpinsAwarded;
      this._spinsLeft = task.data.freeSpinsAwarded - 1;

      this._startHolder = task;
      this._startHolder.join();

      this._fsActive = true;

      const self = this;
      timerManager.addTimeout(500, function () {
        self.onDelayedFsStart();
      });
    }

    onDelayedFsStart() {
      this.updateCountText();
      this.updateMeterText(true);
      this.updateButtonPositions(true);

      const self = this;

      this._freeSpinsIntroOutro.showIntro(self._freespinsCount, function () {
        self.onFSIntroComplete();
      });
    }

    onFSIntroComplete() {
      const self = this;

      timerManager.addTimer(500, undefined, function () {
        self.freeSpinsTransitionIn();

        self.upgradeFish(self._initLevel);

        timerManager.addTimer(1500, undefined, function () {
          self._startHolder.leave();
          self._startHolder = undefined;
        });
      });
    }

    onFreespinsStartDead(task) {
      musicManager.onFreespinsStart(task.initialTrailLevel - 1);

      this.getNextSpinOutcome();
    }

    onFreespinsAwarded(task) {}

    freeSpinsTransitionIn() {
      messageBus.post("freeSpinsTransitionIn");

      soundManager.play("trailIntro");

      if (!gameController.maxPlayActive) {
        for (let i = 0; i < this._baseFadeAssets.length; i++) {
          gsap.fromTo(
            this._baseFadeAssets[i],
            { visible: true, alpha: 1 },
            {
              alpha: 0,
              duration: 2,
            }
          );
        }
      }

      for (let i = 0; i < this._fsFadeAssets.length; i++) {
        gsap.fromTo(
          this._fsFadeAssets[i],
          { visible: true, alpha: 0 },
          {
            alpha: 1,
            duration: 2,
          }
        );
      }

      gsap.to(this._logo, {
        duration: 0.3,
        alpha: 0,
        onComplete: () => {
          this._logo.visible = false;
        },
      });

      this._trailPanelContainer.scale.set(0);
      this._trailPanelContainer.visible = true;
      gsap.to(this._trailPanelContainer.scale, {
        duration: 1.5,
        delay: 0,
        x: 1,
        y: 1,
        ease: "elastic.out(1,0.4)",
      });
    }

    freeSpinsTransitionOut() {
      messageBus.post("freeSpinsTransitionOut");

      for (let i = 0; i < this._fsFadeAssets.length; i++) {
        gsap.fromTo(
          this._fsFadeAssets[i],
          { visible: true, alpha: 1 },
          {
            alpha: 0,
            duration: 1,
          }
        );
      }

      if (!gameController.maxPlayActive) {
        for (let i = 0; i < this._baseFadeAssets.length; i++) {
          gsap.fromTo(
            this._baseFadeAssets[i],
            { visible: true, alpha: 0 },
            {
              alpha: 1,
              duration: 1,
            }
          );
        }
      }

      gsap.to(this._logo, {
        duration: 0.3,
        delay: 1,
        alpha: 1,
        onStart: () => {
          const portrait =
            layoutController.getCurrentLayout() === "portrait_mobile" ||
            layoutController.getCurrentLayout() === "portrait_default";
          this._logo.visible = !portrait;
        },
      });

      gsap.to(this._trailPanelContainer.scale, {
        duration: 1,
        x: 0,
        y: 0,
        ease: "power1.inOut",
        onComplete: () => {
          this._trailPanelContainer.visible = false;
          this._trailPanelContainer.scale.set(1);
          this._trailPanel.reset();
          gameController.swapAnchorToRod();
          this.removeAnchorLocksInstant();
        },
      });
    }

    hideReel() {
      let reels = resourceManager.get("slotContainer:reelContainer");

      var bonusID = resourceManager.getConfiguration().symbols["Bonus"].ID;
      let animStrips = [];

      for (var reelID = 0; reelID < reelManager.reels.length; reelID++) {
        var animStrip = resourceManager.get(reelManager.reels[reelID].linkedAnimations[0].name);
        animStrips.push(animStrip);
      }

      timerManager.addTimer(
        300,
        function (progress) {
          animStrips.forEach((strip) => {
            strip.alpha = 1 - progress;
          });

          reels.alpha = 1.0 - progress;
        },
        function () {
          reels.alpha = 0;

          animStrips.forEach((strip) => {
            strip.hideAllAnimations();
          });

          for (var i = 0; i < reelManager.reels.length; i++) {
            for (var j = 0; j < 3; j++) {
              if (reelManager.reels[i].symbolData[j].symbolId === bonusID) {
                gameData.reels[i].showSymbol(j, true);
              }
            }
          }
        }
      );
    }

    onFreespinsAwardedEnd() {
      gdk.getNextGameOutcome(function () {});
    }

    onFreespinsData(task) {
      task.join();

      this.doFishermanAnimations(true, function () {
        task.leave();
      });
    }

    doFishermanAnimations(canUpgrade, cb) {
      const self = this;
      this._trailPanel.doFishermenTrailAnimation(function () {
        self.doLockedFishermen(canUpgrade, cb);
      });
    }

    doLockedFishermen(canUpgrade, cb) {
      if (!canUpgrade) {
        cb();
        return;
      }

      if (gameController.allLockedFishermen.length === 0) {
        cb();
        return;
      }

      if (gameController.newlyLocked.length === 0) {
        cb();
        return;
      }

      soundManager.play("trailUpgrade");

      for (let i = 0; i < gameController.newlyLocked.length; i++) {
        const cell = gameController.newlyLocked[i];
        const coord = helpers.getSymbolPos(cell.reel, cell.row);
        const anims = this.getAnchorLock();
        const scale = resourceManager.get("slotContainer").scale;

        const reel = resourceManager.get("slotContainer:reelContainer:reel" + cell.reel);
        reel.setReelSymbol(cell.row, 20);

        const anchor = anims.anchor;
        anchor.visible = true;
        anchor.x = coord.x;
        anchor.y = coord.y;
        anchor.scale = scale;
        anchor.gotoAndPlay(0);

        const lock = anims.lock;
        lock.visible = true;
        lock.x = coord.x;
        lock.y = coord.y;
        lock.scale = scale;
        lock.gotoAndPlay(0);

        const reverseAnchor = anims.reverseAnchor;
        reverseAnchor.visible = false;
        reverseAnchor.x = coord.x;
        reverseAnchor.y = coord.y;
        reverseAnchor.scale = scale;

        const reverseLock = anims.reverseLock;
        reverseLock.visible = false;
        reverseLock.x = coord.x;
        reverseLock.y = coord.y;
        reverseLock.scale = scale;

        this._anchorLocks.push({ anchor, lock, reverseAnchor, reverseLock, cell });
      }

      timerManager.addTimeout(1800, function () {
        cb();
      });
    }

    removeAnchorLocks() {
      const self = this;

      if (this._anchorLocks.length > 0) {
        soundManager.play("fishermanRemoveAnchor");
      }

      this._anchorLocks.forEach((anchorLock) => {
        anchorLock.reverseAnchor.visible = true;
        anchorLock.reverseAnchor.gotoAndPlay(0);
        anchorLock.reverseLock.visible = true;
        anchorLock.reverseLock.gotoAndPlay(0);

        anchorLock.anchor.visible = false;
        anchorLock.lock.visible = false;

        anchorLock.reverseAnchor.onComplete = function () {
          anchorLock.reverseAnchor.visible = false;
          anchorLock.reverseLock.visible = false;

          self._anchorLockPool.push(anchorLock);

          self._anchorLocks = [];
        };
      });
    }

    removeAnchorLocksInstant() {
      this._anchorLocks.forEach((anchorLock) => {
        anchorLock.anchor.visible = false;
        anchorLock.lock.visible = false;
        anchorLock.reverseAnchor.visible = false;
        anchorLock.reverseLock.visible = false;

        this._anchorLockPool.push(anchorLock);
      });

      this._anchorLocks = [];
    }

    getUpgrade() {
      let overlay = undefined;

      if (this._upgrades.length > 0) {
        overlay = this._upgrades.pop();
      } else {
        overlay = resourceManager.createObject("movie", "upgrade" + this._upgradesCreated, "trailFishermenContainer", {
          definition: "upgrade",
          anchor: 0.5,
        });
        overlay.loop = false;
        this._upgradesCreated++;
      }
      return overlay;
    }

    getAnchorLock() {
      let anchorLock = undefined;

      if (this._anchorLockPool.length > 0) {
        anchorLock = this._anchorLockPool.pop();
      } else {
        const anchor = resourceManager.createObject(
          "movie",
          "anchor" + this._anchorLockCreated,
          "fishermenOverlayContainer",
          { definition: "fishermanAnchor", anchor: 0.5 }
        );
        anchor.loop = false;

        const reverseAnchor = resourceManager.createObject(
          "movie",
          "reverseAnchor" + this._anchorLockCreated,
          "fishermenOverlayContainer",
          { definition: "fishermanAnchorReverse", anchor: 0.5 }
        );
        reverseAnchor.loop = false;

        const lock = resourceManager.createObject(
          "movie",
          "lock" + this._anchorLockCreated,
          "fishermenOverlayContainer",
          { definition: "fishermanLock", anchor: 0.5 }
        );
        lock.loop = false;

        const reverseLock = resourceManager.createObject(
          "movie",
          "reverseLock" + this._anchorLockCreated,
          "fishermenOverlayContainer",
          { definition: "fishermanLockReverse", anchor: 0.5 }
        );
        reverseLock.loop = false;

        ++this._anchorLockCreated;

        anchorLock = { anchor, lock, reverseAnchor, reverseLock };
      }
      return anchorLock;
    }

    onFreespinsDataDeadEvent(task) {
      if (task.respinsAdded === 0) {
        this.startNextSpin();
        this._waitForPopup = false;
      } else {
        this._waitForPopup = true;
      }
    }

    startNextSpin() {
      this._spinsLeft--;

      if (this._winningsThisSpin > 0) {
        this.getNextSpinOutcome();
      } else {
        const self = this;
        timerManager.addTimer(450, undefined, function () {
          self.getNextSpinOutcome();
        });
      }
    }

    onFreespinsRetriggerEvent(task) {
      this._retriggerHolder = task;
      this._retriggerHolder.join();

      const self = this;

      this._trailPanel.stopEmitters(task.data.trailLevel);

      this._upgradePopup.showUpgradePopup(task.data.trailLevel, function () {
        self._retriggerHolder.leave();

        let timer = 1;

        const upgraded = self.upgradeFish(task.data.trailLevel);

        if (upgraded) {
          timer = 1000;
        }

        if (self._waitForPopup) {
          self._waitForPopup = false;

          timerManager.addTimeout(timer, () => {
            self.startNextSpin();
          });
        }
      });

      this._spinsLeft += task.data.num;
      this._freespinsCount += task.data.num;

      this.updateCountText();
    }

    upgradeFish(level) {
      const self = this;
      let fishOld = [];
      let fishNew = 0;
      let upgraded = false;

      switch (level) {
        case 1:
          fishOld = [10, 11, 32, 31];
          fishNew = 9;
          break;

        case 2:
          fishOld = [9, 10, 11, 32, 31, 30];
          fishNew = 8;
          break;

        case 3:
          fishOld = [8, 9, 10, 11, 32, 31, 30, 29];
          fishNew = 7;
          break;

        case 4:
          fishOld = [7, 8, 9, 10, 11, 32, 31, 30, 29, 28];
          fishNew = 6;
          break;
      }

      for (var i = 0; i < 5; i++) {
        const reel = resourceManager.get("slotContainer:reelContainer:reel" + i);

        for (let j = 0; j < 3; ++j) {
          const sym = reel.getReelSymbol(j);

          const found = fishOld.find((fish) => fish === sym);

          if (found != undefined) {
            const upgrade = this.getUpgrade();
            const pos = helpers.getSymbolPos(i, j);
            const scale = resourceManager.get("slotContainer").scale;

            upgrade.x = pos.x;
            upgrade.y = pos.y;
            upgrade.scale = scale;
            upgrade.visible = true;

            upgrade.gotoAndPlay(0);
            upgrade.onComplete = function () {
              upgrade.visible = false;

              self._upgrades.push(upgrade);
            };

            reel.setReelSymbol(j, fishNew);
            upgraded = true;
          }
        }
      }

      if (upgraded) {
        soundManager.play("fishUpgrade");
      }

      return upgraded;
    }

    doBigWinCheck() {
      let totalWinnings = this._endHolder.data.totalWinnings;

      const bigWinClass = resourceManager.get("bigWin");

      let isBigWin = bigWinClass.willTriggerBigWin(totalWinnings);
      this._fsActive = false;

      if (gameController.boughtBonus) {
        if (totalWinnings <= gameController.globalHelperGetStake()) {
          isBigWin = false;
        }
      }

      if (isBigWin) {
        bigWinClass.start(
          totalWinnings,
          () => {
            this.endFreespins(true);
          },
          false
        );
      } else {
        this.endFreespins(false);
      }
    }

    onFreespinsEndEvent(task) {
      const self = this;

      this._endHolder = task;
      this._endHolder.join();

      let isCapped = this._endHolder.data.isCapped.winCapped;

      if (isCapped) {
        const bigWinClass = resourceManager.get("bigWin");

        bigWinClass.showCappedWinPopup(() => {
          self.doOutro();
        });
      } else {
        this.doFishermanAnimations(false, function () {
          self.doOutro();
        });
      }
    }

    doOutro() {
      this._fsActive = false;
      this._skipOutroMove = false;

      messageBus.unsubscribe("spinner:SpinEvent", this._doSpinFunc);
      messageBus.unsubscribe("spinner:WinningLinesEventDead", this._payWinsDeadFunc);
      messageBus.unsubscribe("spinner:SpinEventDead", this._doSpinDeadFunc);

      this._outroPopup = this._outroPopupWin;
      this._outroPopupButton = this._outroPopupWinButton;

      this.updateMeterText(false);
      this.updateButtonPositions(false);

      gameData.winningsMeter.set(this._endHolder.data.totalWinnings);
      gameController.totalWinnings = this._endHolder.data.totalWinnings;

      timerManager.addTimeout(1500, () => {
        this.freeSpinsTransitionOut();
      });

      gameController.fsWinnings = this._endHolder.data.fsWinnings;

      timerManager.addTimeout(750, () => {
        musicManager.wasInFreeSpins = true;

        this._freeSpinsIntroOutro.showOutro(this._endHolder.data.fsWinnings, () => {
          this.doBigWinCheck();
        });
      });
    }

    endFreespins(bigWin) {
      if (bigWin) {
        this._endHolder.leave();
        this._endHolder = undefined;
        resourceManager.getController("inputOverlord").setState("enabled");
        gameController.boughtBonus = false;
      } else {
        timerManager.addTimeout(700, () => {
          this._endHolder.leave();
          this._endHolder = undefined;
          resourceManager.getController("inputOverlord").setState("enabled");
          gameController.boughtBonus = false;
        });
      }
    }

    onFreespinsEndEventDead(task) {
      gameData.mainTunePlaying = true;
    }

    doPayWins(task) {
      this._winningsThisSpin = task.data.totalLineWinnings;
    }

    doPayWinsDead(task) {
      this._winnings += task.totalLineWinnings;
    }
  }

  new Freespins();
})();
